import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.starts-with.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { constantRoutes } from '@/router';
import { getMenus } from '@/api/menu';
import Layout from '@/layout/index';
import ParentView from '@/components/ParentView';
import InnerLink from '@/layout/components/InnerLink';
var state = {
  routes: [],
  addRoutes: [],
  defaultRoutes: [],
  topbarRouters: [],
  sidebarRouters: []
};
var mutations = {
  SET_ROUTES: function SET_ROUTES(state, routes) {
    state.addRoutes = routes;
    state.routes = constantRoutes.concat(routes);
  },
  SET_DEFAULT_ROUTES: function SET_DEFAULT_ROUTES(state, routes) {
    state.defaultRoutes = constantRoutes.concat(routes);
  },
  SET_TOPBAR_ROUTES: function SET_TOPBAR_ROUTES(state, routes) {
    // 顶部导航菜单默认添加统计报表栏指向首页
    state.topbarRouters = routes;
  },
  SET_SIDEBAR_ROUTERS: function SET_SIDEBAR_ROUTERS(state, routes) {
    state.sidebarRouters = routes;
  }
};
var actions = {
  generateRoutes: function generateRoutes(_ref) {
    var commit = _ref.commit;
    return new Promise(function (resolve) {
      getMenus().then(function (res) {
        var sdata = JSON.parse(JSON.stringify(res.data));
        var rdata = JSON.parse(JSON.stringify(res.data));
        var sidebarRoutes = filterAsyncRouter(sdata);
        var rewriteRoutes = filterAsyncRouter(rdata, false, true);
        rewriteRoutes.push({
          path: '*',
          redirect: '/404',
          hidden: true
        });
        commit('SET_ROUTES', rewriteRoutes);
        commit('SET_SIDEBAR_ROUTERS', constantRoutes.concat(sidebarRoutes));
        commit('SET_DEFAULT_ROUTES', sidebarRoutes);
        commit('SET_TOPBAR_ROUTES', sidebarRoutes);
        resolve(rewriteRoutes);
      });
    });
  },
  clearRoutes: function clearRoutes(_ref2) {
    var commit = _ref2.commit;
    commit('SET_ROUTES', []);
    // resetRouter() // 重置路由器
  }
};

// 遍历后台传来的路由字符串，转换为组件对象
function filterAsyncRouter(asyncRouterMap) {
  var lastRouter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  return asyncRouterMap.filter(function (route) {
    if (type && route.children) {
      route.children = filterChildren(route.children);
    }
    if (route.component) {
      // Layout ParentView 组件特殊处理
      if (route.component === 'Layout') {
        route.component = Layout;
      } else if (route.component === 'ParentView') {
        route.component = ParentView;
      } else if (route.component === 'InnerLink') {
        route.component = InnerLink;
      } else {
        route.component = loadView(route.component);
      }
    }
    if (route.children != null && route.children && route.children.length) {
      route.children = filterAsyncRouter(route.children, route, type);
    } else {
      delete route['children'];
      delete route['redirect'];
    }
    return true;
  });
}
function filterChildren(childrenMap) {
  var lastRouter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var children = [];
  childrenMap.forEach(function (el, index) {
    if (el.children && el.children.length) {
      if (el.component === 'ParentView') {
        el.children.forEach(function (c) {
          c.path = el.path + '/' + c.path;

          // 如果有params，将其添加到meta中而不是直接拼接到path
          if (c.params) {
            if (!c.meta) c.meta = {};
            // 确保params是一个对象，而不是字符串
            if (typeof c.params === 'string') {
              try {
                // 尝试解析JSON字符串
                c.meta.params = JSON.parse(c.params);
              } catch (e) {
                // 如果解析失败，尝试处理非标准格式如 {type:2}
                if (c.params.startsWith('{') && c.params.includes(':')) {
                  var fixedParams = c.params.replace(/(\w+):/g, '"$1":');
                  try {
                    c.meta.params = JSON.parse(fixedParams);
                  } catch (e2) {
                    // 如果仍然失败，则保存原始字符串
                    c.meta.params = c.params;
                  }
                } else {
                  c.meta.params = c.params;
                }
              }
            } else {
              // 如果已经是对象，直接使用
              c.meta.params = c.params;
            }
          }
          if (c.children && c.children.length > 0) {
            children = children.concat(filterChildren(c.children, c));
            return;
          }
          children.push(c);
        });
        return;
      }
    }
    if (lastRouter) {
      el.path = lastRouter.path + '/' + el.path;
      // 如果有params，将其添加到meta中而不是直接拼接到path
      if (el.params) {
        if (!el.meta) el.meta = {};
        // 确保params是一个对象，而不是字符串
        if (typeof el.params === 'string') {
          try {
            // 尝试解析JSON字符串
            el.meta.params = JSON.parse(el.params);
          } catch (e) {
            // 如果解析失败，尝试处理非标准格式如 {type:2}
            if (el.params.startsWith('{') && el.params.includes(':')) {
              var fixedParams = el.params.replace(/(\w+):/g, '"$1":');
              try {
                el.meta.params = JSON.parse(fixedParams);
              } catch (e2) {
                // 如果仍然失败，则保存原始字符串
                el.meta.params = el.params;
              }
            } else {
              el.meta.params = el.params;
            }
          }
        } else {
          // 如果已经是对象，直接使用
          el.meta.params = el.params;
        }
      }
    }
    children = children.concat(el);
  });
  return children;
}
export var loadView = function loadView(view) {
  // 路由懒加载
  return function (resolve) {
    return require(["@/views/".concat(view, ".vue")], resolve);
  };
};
export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions
};